export default () => ({
    mobileVideoHtml: null,
    mobilePoster: null,
    desktopVideoHtml: null,
    desktopPoster: null,

    init() {
        const video = this.$root
        const mobileVideoTemplate = video.querySelector(
            '[data-mobile-video-content]'
        )
        const desktopVideoTemplate = video.querySelector(
            '[data-desktop-video-content]'
        )

        if (!desktopVideoTemplate) {
            throw new Error(
                'Video component requires a video element and a template element'
            )
        }

        this.desktopVideoHtml = desktopVideoTemplate.innerHTML
        this.desktopPoster = video.dataset.poster

        if (!mobileVideoTemplate) {
            video.innerHTML = this.desktopVideoHtml
            video.setAttribute('poster', this.desktopPoster)
            video.load()
            if (video.dataset.autoplay) {
                video.play().catch(() => {})
            }
            return
        }

        this.mobileVideoHtml = mobileVideoTemplate.innerHTML
        const templateContent = mobileVideoTemplate.content
        this.mobilePoster = templateContent
            .querySelector('img')
            .getAttribute('src')

        const mql = window.matchMedia('(orientation: landscape)')

        mql.addEventListener('change', this.switchVideoSources.bind(this))

        this.switchVideoSources(mql)
    },
    switchVideoSources(e) {
        const video = this.$root

        if (e.matches) {
            video.innerHTML = this.desktopVideoHtml
            video.setAttribute('poster', this.desktopPoster)
        } else {
            video.innerHTML = this.mobileVideoHtml
            video.setAttribute('poster', this.mobilePoster)
        }

        video.load()

        if (video.dataset.autoplay) {
            video.play().catch(() => {})
        }
    },
})
